// @import dependencies
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment';
// @end

// @import components
import { ActivityDetailsModuleLayout } from 'app_components/modules/campus/academic/activityDetails'
// @end

// @import events
// @end

// @import utils
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
// @end

// @import services
import storeService from 'app_services/storeService'
import CourseActivityService from 'app_services/campus/academic/courseActivityService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { IMyCourse } from 'app_types/campus/academic/myCoursesTypes'
import { IActivityDetailTags } from 'app_types/campus/academic/activityDetailsTypes'
import { moodleAuthFormRequest } from 'app_events/auth/actions';
// @end

// @ADD Component types
interface IActivityDetailsModuleProps { }
interface IActivityDetailsModuleState {
  status: null | 'loading' | 'error'
  activityData: Array<any>
  pagination: IPagination
  tags: Array<IActivityDetailTags>
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => { return state }

class ActivityDetailsModule extends Component<IActivityDetailsModuleProps, IActivityDetailsModuleState> {

  private courseActivityService: CourseActivityService
  private i18nUtil: I18nUtil
  private screenNotifications: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IActivityDetailsModuleProps) {
    super(props)
    this.i18nUtil = new I18nUtil()
    this.screenNotifications = new ScreenNotificationsUtil()

    this.courseActivityService = new CourseActivityService()

    this.state = {
      status: 'loading',
      activityData: [],
      pagination: {
        page: 1,
        perPage: 10,
        total: 0,
      },
      tags: this.courseActivityService.getActivityTags()
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected', this.fetchActivityDetails)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected', this.fetchActivityDetails)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => { }

  // @Add custom methods

  handleJoinMeeting = (url: string) => {
    const authStatus = storeService?.getMoodleAuthStatus() || false
    if (!authStatus) {
      storeService?.dispatch(moodleAuthFormRequest(true))
      this.screenNotifications.fire({
        'message': 'Iniciando sesión en moodle',
      }, {
        'type': 'warning',
        'showCancelButton': false,
        'showConfirmButton': false,
        'allowOutsideClick': false,
        'allowEscapeKey': false,
        timer: 3000,
      })?.then(() => {
        window.location.href = url
      })
    } else {
      window.location.href = url
    }
  }

  joinMeetingButton = (url: string | null) => {
    if (!url) return;
    return (
      <button className='join-meeting-button' onClick={() => this.handleJoinMeeting(url)}>
        Join
      </button>
    )
  }

  extractUrlFromTag (tag: string) {
    const regex = new RegExp(/href="(.*?)"/, 'g')
    if (!regex) return null;
    const regexExec = regex.exec(tag)
    if (!regexExec || !regexExec[1]) return null;
    return regexExec[1]
  }

  fetchActivityDetails = async (data: IMyCourse | null) => {

    console.log('data: ', data)

    this.setState({
      status: 'loading',
      activityData: [],
      pagination: {
        page: 1,
        perPage: 10,
        total: 0
      }
    })

    if (data?._id) {
      const startOfMonth = `${moment().startOf('month').format('YYYY-MM-DD')}T00:00:00Z`;
      const endOfMonth = `${moment().endOf('month').format('YYYY-MM-DD')}T23:59:59Z`;

      const dataResponse = await this.courseActivityService.fetchActivityCalendar({
        courseID: data?._id,
        timeStart: startOfMonth,
        timeEnd: endOfMonth,
        courseSchedulingId: data?.courseScheduling,
        events: ["assign", "attendance", "quiz", "forum", "session"]
      })

      if (dataResponse && dataResponse.events) {
        let count = 0
        const tags: any = this.state.tags.reduce((accum, element) => ({ ...accum, [element.key.toString()]: element }), {})
        const events = dataResponse.events.reduce((accum: Array<any>, element) => {

          let startDate = (element.timestart != null) ? moment(element.timestart).format('DD/MM/YYYY') : null;
          let endDate = (element.timefinish != null) ? moment(element.timefinish).format('DD/MM/YYYY') : null;
          let component = undefined;

          if (element?.eventtype === 'webex') {
            startDate = (element.timestart != null) ? moment(element.timestart).format('DD/MM/YYYY HH:mm') : null;
            endDate = (element.timefinish != null) ? moment(element.timefinish).format('DD/MM/YYYY HH:mm') : null;
            if (endDate) {
              const today = moment()
              const isActive = moment(element.timefinish).isSameOrAfter(today)
              if (isActive) {
                if (element?.url) {
                  component = this.joinMeetingButton(
                    element.url
                  )
                } else if (element?.description) {
                  component = this.joinMeetingButton(
                    this.extractUrlFromTag(element?.description)
                  )
                }
              }
            }
          }

          accum.push({
            _id: element.id,
            position: `${(count) + 1}`,
            activity: element.name,
            module: element.modulename,
            start_date: startDate,
            limit_date: endDate,
            delivery_date: (element.timecompleted != null) ? moment(element.timecompleted).format('DD/MM/YYYY') : null,
            circle_component: (tags && tags[element.status]) ? tags[element.status].color : null,
            component_render_actions: component
          })
          count++

          return accum
        }, [])
        this.setState({ activityData: events, status: null })
      } else {
        this.setState(({ status: null }))
      }
    } else {
      this.setState(({ status: null }))
    }
  }

  render() {
    return (
      <ActivityDetailsModuleLayout
        status={this.state.status}
        activityData={this.state.activityData}
        pagination={this.state.pagination}
        // onPageChange={this.onPageChange}
        tags={this.state.tags}
      />
    )
  }
}

export default connect(mapStatesToProps)(ActivityDetailsModule)
